/*
	Copyright (c) 2022 PierceGearhart
    StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (StellaNode).
*/

import { Link } from 'react-router-dom'
import { useState } from 'react'

type Props = {
    type: 'link' | 'dropdown'
    link?: any
    description?: string
    title: string
}

const MobileItem: React.FC<Props> = ({ type, link, title, description, children }) => {
    const [dropdownState, setDropdownState] = useState(false)

    return (
        <li className="text-gray-300 font-medium text-xl py-1">
            {type === 'link' ?
                <Link to={link}>
                    {title}
                </Link>
            :
                <>
                    <span className='cursor-pointer select-none' onClick={() => dropdownState === true ? setDropdownState(false) : setDropdownState(true)}>{title}</span>
                    {dropdownState === true &&
                        <div className="mobile-dropdown pt-6 mb-3">
                            <div className="dropdown-inner">
                                <div className="bg-primary py-7 px-9 border-t-2 rounded-md">
                                    <h1 className="text-gray-100 text-xl font-semibold mb-1.5">{title}</h1>
                                    <p className="text-sm text-gray-300 mb-5">{description}</p>
                                    <ul className="links">
                                        {children}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    }
                </>
            }
        </li>
    )
}

export default MobileItem